import loadable from '@loadable/component';
import React, { FunctionComponent } from 'react';
import { SettingsContext } from '../../context';
import { AppProps } from '../../types';
import { useAddHandlersToNodes } from '../utils/hooks';

const LazyReportThisEvent = loadable.lib(
    () => import('@eventbrite/report-this-event'),
);

interface ReportThisEventProps {
    domNodeId: string;
    onClose: () => void;
    isVisible: boolean;
    eventId: string;
}

const ReportThisEventController: React.FunctionComponent<{
    isReportThisEventVisible: boolean | null;
    setisReportThisEventVisible: Function;
    event: { id: string };
}> = (props) => {
    const {
        isReportThisEventVisible,
        setisReportThisEventVisible,
        event,
    } = props;

    return (
        <>
            {isReportThisEventVisible !== null ? (
                <LazyReportThisEvent>
                    {({
                        ReportThisEvent,
                    }: {
                        ReportThisEvent: FunctionComponent<
                            ReportThisEventProps
                        >;
                    }) => (
                        <ReportThisEvent
                            domNodeId="listings-root"
                            eventId={event.id}
                            onClose={() => setisReportThisEventVisible(false)}
                            isVisible={isReportThisEventVisible}
                        />
                    )}
                </LazyReportThisEvent>
            ) : null}
        </>
    );
};

export const ReportThisEventRoot = (props: AppProps) => {
    const {
        featureFlags: { launchReportThisEventOnListings = false } = {},
    } = React.useContext(SettingsContext);
    const [
        isReportThisEventVisible,
        setisReportThisEventVisible,
    ] = React.useState<null | boolean>(null);

    useAddHandlersToNodes({
        querySelector: '#report_this_link--react',
        callback: React.useCallback(() => {
            setisReportThisEventVisible(!isReportThisEventVisible);
        }, [isReportThisEventVisible]),
        delaySelector: true,
        retry: true,
        enabled: launchReportThisEventOnListings,
    });

    if (!launchReportThisEventOnListings) {
        return null;
    }

    return (
        <>
            <ReportThisEventController
                {...props}
                isReportThisEventVisible={isReportThisEventVisible}
                setisReportThisEventVisible={setisReportThisEventVisible}
            />
        </>
    );
};
